// Toggles between a "primary" (collapsed) and "secondary" (expanded) view.
// Used on the overview breakdown table and the Gmail thread message list.
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["primary", "secondary"];

  connect() {
    this.secondaryTargets.forEach((element) => {
      element.style.display = "none";
    });
    this.data.set("toggle", "false");
  }

  toggle(event) {
    if (this.data.get("toggle") == "true") {
      this.data.set("toggle", "false");
      this.primaryTargets.forEach((element) => {
        element.style.display = "";
      });
      this.secondaryTargets.forEach((element) => {
        element.style.display = "none";
      });
    } else {
      this.data.set("toggle", "true");
      this.primaryTargets.forEach((element) => {
        element.style.display = "none";
      });
      this.secondaryTargets.forEach((element) => {
        element.style.display = "";
      });
      this.resizeRevealedFrames();
    }
  }

  // Email bodies render in an iframe whose height is set by an inline `onload`
  // handler. When a message loads while collapsed (display: none) that handler
  // measures a zero height, leaving a small scrollable frame. Re-fire `load`
  // once the frame is visible so it resizes to its content.
  resizeRevealedFrames() {
    requestAnimationFrame(() => {
      this.secondaryTargets.forEach((element) => {
        element
          .querySelectorAll("iframe.email-content-frame")
          .forEach((frame) => frame.dispatchEvent(new Event("load")));
      });
    });
  }
}
